<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div
        class="group relative overflow-hidden rounded-2xl border border-white/10 bg-slate-950/40 backdrop-blur-2xl
         ring-1 ring-white/5 hover:ring-white/10 transition"
    >
      <div class="pointer-events-none absolute -inset-24 opacity-40 blur-3xl bg-gradient-to-r from-indigo-500/30 via-fuchsia-400/10 to-transparent" />
      <div class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_15%,rgba(255,255,255,0.10),transparent_45%)]" />
      <div class="pointer-events-none absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.06),transparent_35%)]" />

      <div class="relative p-5 md:p-6">
        <div class="flex items-start justify-between gap-4">
          <div class="min-w-0">
            <div class="flex items-center gap-2">
              <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/5">
                <v-icon color="white">fa-check</v-icon>
              </span>
              <div class="min-w-0">
                <h3 class="text-slate-200 font-semibold text-base md:text-lg leading-tight">
                  سفارش‌های پرداخت‌ شده
                </h3>
                <p class="text-xs text-slate-400 mt-0.5">مجموع کل (تومان)</p>
              </div>
            </div>

            <p class="mt-4 text-2xl md:text-3xl font-extrabold tracking-tight text-indigo-300">
              {{ totals.paid_total | toMoney }}
            </p>

            <div class="mt-3 flex items-center gap-2 text-xs text-slate-400">
              <span class="inline-flex items-center gap-1 rounded-lg border border-white/10 bg-white/5 px-2 py-1">
                <span class="h-2 w-2 rounded-full bg-indigo-400/90"></span>
                سهم از کل: {{ paidPercent }}%
              </span>
              <span class="truncate opacity-80">نمودار نسبت به مجموع دو کارت</span>
            </div>
          </div>

          <!-- Ring -->
          <div class="shrink-0">
            <svg class="w-20 h-20 md:w-24 md:h-24 drop-shadow-lg transition-transform duration-200 group-hover:scale-[1.03]" viewBox="0 0 36 36">
              <!-- Track -->
              <path
                  class="text-white/10"
                  stroke="currentColor"
                  stroke-width="3.5"
                  stroke-linecap="round"
                  fill="none"
                  d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path
                  class="text-indigo-400"
                  stroke="currentColor"
                  stroke-width="3.5"
                  stroke-linecap="round"
                  fill="none"
                  :stroke-dasharray="dashArray(paidPercent)"
                  d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="50%" y="50%" text-anchor="middle" dy=".35em" class="fill-indigo-200 font-bold text-[7px]">
                {{ paidPercent }}%
              </text>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div
        class="group relative overflow-hidden rounded-2xl border border-white/10 bg-slate-950/40 backdrop-blur-2xl
         ring-1 ring-white/5 hover:ring-white/10 transition"
    >
      <div class="pointer-events-none absolute -inset-24 opacity-40 blur-3xl bg-gradient-to-r from-emerald-500/30 via-cyan-400/10 to-transparent" />
      <div class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_15%,rgba(255,255,255,0.10),transparent_45%)]" />
      <div class="pointer-events-none absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.06),transparent_35%)]" />

      <div class="relative p-5 md:p-6">
        <div class="flex items-start justify-between gap-4">
          <div class="min-w-0">
            <div class="flex items-center gap-2">
              <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/5">
                <v-icon color="white">fa-box</v-icon>
              </span>
              <div class="min-w-0">
                <h3 class="text-slate-200 font-semibold text-base md:text-lg leading-tight">
                  سفارش‌های ارسال‌شده
                </h3>
                <p class="text-xs text-slate-400 mt-0.5">مجموع کل (تومان)</p>
              </div>
            </div>

            <p class="mt-4 text-2xl md:text-3xl font-extrabold tracking-tight text-emerald-300">
              {{ totals.shipped_total | toMoney }}
            </p>

            <div class="mt-3 flex items-center gap-2 text-xs text-slate-400">
              <span class="inline-flex items-center gap-1 rounded-lg border border-white/10 bg-white/5 px-2 py-1">
                <span class="h-2 w-2 rounded-full bg-emerald-400/90"></span>
                سهم از کل: {{ shippedPercent }}%
              </span>
              <span class="truncate opacity-80">نمودار نسبت به مجموع دو کارت</span>
            </div>
          </div>

          <!-- Ring -->
          <div class="shrink-0">
            <svg class="w-20 h-20 md:w-24 md:h-24 drop-shadow-lg transition-transform duration-200 group-hover:scale-[1.03]" viewBox="0 0 36 36">
              <!-- Track -->
              <path
                  class="text-white/10"
                  stroke="currentColor"
                  stroke-width="3.5"
                  stroke-linecap="round"
                  fill="none"
                  d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <!-- Progress -->
              <path
                  class="text-emerald-400"
                  stroke="currentColor"
                  stroke-width="3.5"
                  stroke-linecap="round"
                  fill="none"
                  :stroke-dasharray="dashArray(shippedPercent)"
                  d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="50%" y="50%" text-anchor="middle" dy=".35em" class="fill-emerald-200 font-bold text-[7px]">
                {{ shippedPercent }}%
              </text>
            </svg>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "OrdersTotal",
  data() {
    return {
      totals: {
        shipped_total: 0,
        paid_total: 0,
      },
      nowLabel: "",
      _tick: null,
    };
  },
  created() {
    this.fetchTotals();
    this.updateNowLabel();
    this._tick = setInterval(this.updateNowLabel, 30 * 1000);
  },
  beforeDestroy() {
    if (this._tick) clearInterval(this._tick);
  },
  computed: {
    sumAll() {
      const s = Number(this.totals.shipped_total || 0);
      const p = Number(this.totals.paid_total || 0);
      return s + p;
    },
    shippedPercent() {
      if (!this.sumAll) return 0;
      return Math.min(100, Math.max(0, Math.round((this.totals.shipped_total / this.sumAll) * 100)));
    },
    paidPercent() {
      if (!this.sumAll) return 0;
      return Math.min(100, Math.max(0, Math.round((this.totals.paid_total / this.sumAll) * 100)));
    },
  },
  methods: {
    fetchTotals() {
      this.request({
        url: this.endpoint("shop/ordersSum"),
        method: "get",
        success: (data) => {
          this.totals = data || this.totals;
        },
      });
    },
    dashArray(percent) {
      const p = Math.min(100, Math.max(0, Number(percent) || 0));
      const safe = p === 0 ? 0.01 : p;
      return `${safe}, 100`;
    },
    updateNowLabel() {
      const d = new Date();
      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");
      this.nowLabel = `${hh}:${mm}`;
    },
  },
};
</script>
